import { useCallback, useEffect, useRef, useState } from 'react';
import { PickerChangeHandlerContext, TimeValidationError } from '@mui/x-date-pickers/models';

import { formatAnchorTime, parseAnchorTime } from './Waypoints.time';

export const useAnchorTimeField = (value: string, onChange: (time: string) => void, resetKey: unknown) => {
  const [draft, setDraft] = useState(() => parseAnchorTime(value));
  const [error, setError] = useState<TimeValidationError>(null);
  const lastValue = useRef(value);
  const lastReset = useRef(resetKey);

  useEffect(() => {
    if (value !== lastValue.current || resetKey !== lastReset.current) {
      setDraft(parseAnchorTime(value));
      setError(null);
      lastValue.current = value;
      lastReset.current = resetKey;
    }
  }, [value, resetKey]);

  const handleChange = useCallback(
    (date: Date | null, context: PickerChangeHandlerContext<TimeValidationError>) => {
      setDraft(date);
      setError(context.validationError);
      const time = formatAnchorTime(date, context.validationError);

      lastValue.current = time;
      onChange(time);
    },
    [onChange]
  );

  return { value: draft, error, onChange: handleChange };
};
